/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import CrohnSurveyFilledJournalEvent from "parog-web/models/crohn-survey-filled-journal-event";
import type SemeiaSessionService from "parog-web/services/session";
import MiciBaseEditionFormEditionForm from "../base-edition-form/edition-form";

export default class MiciCrohnSurveyEditionForm extends MiciBaseEditionFormEditionForm {
  static forcDisplayName = "Questionnaire sur ma maladie";
  static fullComponentId = "mici/crohn-survey-edition-form";

  static journalEventClass = CrohnSurveyFilledJournalEvent;

  @service declare session: SemeiaSessionService;

  get forcDisplayName(): string {
    return this.session.medic ? "Questionnaire Crohn" : "Symptômes";
  }

  get currentSections(): Array<string> {
    return [
      "stoolsNumber",
      ...this.abdominalPainSections,
      "wellBeing",
      ...this.anusSections,
      ...this.fistulasSections,
      ...this.articularPainSections,
      "mouthUlcers",
      "skinSymptoms",
      ...this.eyeSymptomsSections,
      ...this.feverSections,
      "weight",
      "repeatedVomiting",
      "transitBlockage"
    ];
  }

  get abdominalPainSections(): string[] {
    if (this.changeset.get("abdominalPain")) {
      return ["abdominalPain", "abdominalPainIntensity"];
    }
    return ["abdominalPain"];
  }

  get anusSections(): string[] {
    if (this.changeset.get("anusSymptoms")) {
      return ["anusSymptoms", "anusSymptomsFrequency"];
    }
    return ["anusSymptoms"];
  }

  get fistulasSections(): string[] {
    if (this.changeset.get("hasFistulas")) {
      return [
        "hasFistulas",
        "fistulasPain",
        "fistulasEmbarrassment",
        "fistulasFlow",
        "fistulasPainSkin",
        "fistulasMovement"
      ];
    }
    return ["hasFistulas"];
  }

  get articularPainSections(): string[] {
    if (this.changeset.get("articularPain")) {
      return ["articularPain", "articularPainSeverity"];
    }
    return ["articularPain"];
  }

  get eyeSymptomsSections(): string[] {
    if (this.changeset.get("eyeSymptoms")) {
      return [
        "eyeSymptoms",
        "eyeSymptomsRedEye",
        "eyeSymptomsPainful",
        "eyeSymptomsSight"
      ];
    }
    return ["eyeSymptoms"];
  }

  get feverSections(): string[] {
    if (this.changeset.get("fever")) {
      return ["fever", "feverLevel"];
    }
    return ["fever"];
  }
}
